var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Field__Component Field__Component--status",
      class: {
        paid: _vm.isPaid,
        "double-fine": _vm.isDobuleFine,
        open: _vm.isOpen,
        "is-declined": _vm.isDeclined,
        "is-appeal": _vm.isAppealRequested,
        "open-cancled-double": _vm.isOpenCanceledDouble,
        "is-request-trial": _vm.isRequestTrial,
        "is-transfer-at-authority": _vm.isTransferAtAuthority,
        "is-in-collection": _vm.isInCollection
      }
    },
    [_c("div", [_vm._v(_vm._s(_vm.value))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }